// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"86":"fad22d2f","451":"e964c491","848":"e9d1869f","940":"9e0ae83b"}[chunkId] + ".css";
};